import { FC } from 'react'
import classNames from 'classnames/bind'
import { BelgianEnterpriseNumber } from 'constants/regex'
import { removeSpacesAndDots } from 'utils/helpers'
import { CompanyNumberFieldProps as Props } from '../types'
import { useTranslation } from 'react-i18next'

const CompanyNumberFormField: FC<Props> = ({ formState, register, hookFormSelector, isRequired }) => {
  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation'])

  // Constants
  const key = hookFormSelector ?? 'companyNumber'
  const { errors } = formState

  /**
   *
   * @param {string} enterpriseNumber
   * @returns boolean
   */
  const checkIfEnterpriseNumberIsValid = (enterpriseNumber: string): boolean => {
    enterpriseNumber = removeSpacesAndDots(enterpriseNumber)

    const firstEightNumbers = parseInt(enterpriseNumber.substring(0, 8), 10)
    const rest = firstEightNumbers % 97
    const controlDigit = 97 - rest
    const lastTwoNumbers = parseInt(enterpriseNumber.substring(8), 10)

    return controlDigit === lastTwoNumbers
  }

  return (
    <div className="form-input">
      <label htmlFor={key}>{t('companyNumber', 'Ondernemingsnummer')}</label>
      <input
        type="text"
        className={classNames('is-block', { 'has-error': errors && key in errors })}
        {...register(key, {
          required: isRequired,
          validate: {
            format: (val: string) => BelgianEnterpriseNumber.test(removeSpacesAndDots(val)),
            controlDigit: (val: string) => checkIfEnterpriseNumberIsValid(val)
          }
        })}
        placeholder="0123456789"
      />
      {errors && errors.companyNumber && (
        <p className="margin-top-s margin-bottom-none is-red">
          {errors.companyNumber.type === 'required' && t('validation:required')}
          {(errors.companyNumber.type === 'format' || errors.companyNumber.type === 'controlDigit') &&
            t('invalidCompanyNumber', 'Dit is geen geldig ondernemingsnummer.')}
        </p>
      )}
    </div>
  )
}

export default CompanyNumberFormField
